var PrescriptionType;
(function(PrescriptionType) {
    PrescriptionType["EXISTING_CUSTOMER"] = 'ExistingCustomer';
    PrescriptionType["NEW_PRESCRIPTION"] = 'NewPrescription';
    PrescriptionType["PRESCRIPTION_FILE"] = 'PrescriptionFile';
    PrescriptionType["EMAIL_PRESCRIPTION"] = 'EmailPrescription';
    PrescriptionType["OCR_PRESCRIPTION"] = 'OCRPrescription';
})(PrescriptionType || (PrescriptionType = {}));

export { PrescriptionType };
//# sourceMappingURL=types.js.map
